// SEO helper — writes title/description/JSON-LD/keywords into the document head.
// Every page's keywords are automatically merged with a Canadian security
// industry baseline so nationwide terms are always represented in <meta>.

import { CANADA_KEYWORDS_FOR_META } from "./canadaKeywords";

export function setSEO({ title, description, keywords, canonical, jsonLd }) {
  if (typeof document === "undefined") return;

  if (title) document.title = title;

  const set = (attr, value, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}='${value}']`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, value);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  // Merge page keywords with Canadian baseline (dedup, preserve order)
  const pageKeywords = Array.isArray(keywords)
    ? keywords
    : typeof keywords === "string"
    ? keywords.split(",").map((s) => s.trim())
    : [];
  const merged = Array.from(new Set([...pageKeywords, ...CANADA_KEYWORDS_FOR_META]));

  set("name", "description", description);
  set("name", "keywords", merged.join(", "));
  set("property", "og:title", title);
  set("property", "og:description", description);
  set("property", "og:type", "website");
  set("name", "twitter:card", "summary_large_image");
  set("name", "twitter:title", title);
  set("name", "twitter:description", description);
  set(
    "name",
    "robots",
    "index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"
  );
  set("name", "geo.region", "CA-BC");
  set("name", "geo.placename", "British Columbia, Canada");

  if (canonical) {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }

  // JSON-LD
  const existing = document.getElementById("__jsonld__");
  if (existing) existing.remove();
  if (jsonLd) {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = "__jsonld__";
    s.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(s);
  }
}
